import(/* webpackMode: "eager" */ "/opt/actions-runner/_work/cdc-market/cdc-market/src/app/[locale]/price/error.tsx");
